import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReactComponent as ComingSoonImage } from '@backrs_ui/common-ui/src/assets/images/coming-soon.svg';
import { Box, Typography } from '@mui/material';
import { appStrings } from '../assets/appStrings';
import { TYPOGRAPHY_VARIANTS } from '../designSystem/typography/typography';
var COMING_SOON_STRINGS = appStrings.modules.comingSoon;
export var ComingSoon = function () {
    return (_jsxs(Box, { sx: containerSx, children: [_jsx(Box, { sx: imageContainerSx, children: _jsx(ComingSoonImage, {}) }), _jsx(Typography, { sx: comingSoonTextSx, variant: "display-xl-medium", children: COMING_SOON_STRINGS.title })] }));
};
var containerSx = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100svh',
    gap: { xs: '2rem', sm: '4rem' },
    width: '100%',
};
var comingSoonTextSx = {
    textAlign: 'center',
    fontSize: {
        xs: '32px',
        sm: TYPOGRAPHY_VARIANTS['display-xl-medium'].fontSize,
    },
};
var imageContainerSx = {
    svg: {
        width: '100%',
        height: '100%',
    },
};
